var map = {
	"./action_img.png": 90,
	"./background.png": 291,
	"./banner_shap.png": 292,
	"./cloud-computing.png": 293,
	"./cloud_01.png": 91,
	"./cloud_02.png": 92,
	"./cloud_03.png": 93,
	"./cloud_04.png": 94,
	"./cloud_05.png": 95,
	"./cloud_06.png": 96,
	"./crm_img1.jpg": 294,
	"./crm_img2.jpg": 295,
	"./crm_img3.jpg": 296,
	"./erp_dashboard.jpg": 97,
	"./erp_icon1.png": 297,
	"./erp_icon2.png": 298,
	"./erp_icon3.png": 299,
	"./erp_icon4.png": 300,
	"./erp_icon5.png": 301,
	"./erp_icon6.png": 302,
	"./growth.png": 303,
	"./img/01.png": 98,
	"./img/02.png": 99,
	"./img/03.png": 100,
	"./img/04.png": 101,
	"./img/05.png": 102,
	"./img/06.png": 103,
	"./img/07.png": 104,
	"./img/08.png": 105,
	"./img/09.png": 106,
	"./img/10.png": 107,
	"./img/11.png": 108,
	"./img/12.png": 109,
	"./img/13.png": 110,
	"./img/14.png": 111,
	"./img/15.png": 112,
	"./img/16.png": 113,
	"./img/17.png": 114,
	"./img/18.png": 115,
	"./img/19.png": 116,
	"./img/20.png": 117,
	"./quote.png": 304,
	"./rocket.png": 118,
	"./settings1.png": 305,
	"./shape.png": 306,
	"./testimonial_img.jpg": 307,
	"./testimonial_img2.jpg": 308
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70;